{
	"printDate": "Issued on",
	"reportPeriod": "Report period",
	"emissionInfo": "Issued by",
	"eventDate": "Event date"
}
